import FEATURES from 'src/core/constants/features';

import { useFeature } from '../common/hooks/useFeature';

export function useIsVatEnabled(country: string | null) {
  const hasRemoveVatCapability = useFeature(
    FEATURES.CAUTION_REMOVE_VAT_CAPABILITY,
  );

  return country !== 'US' && !hasRemoveVatCapability;
}
